import { z } from 'zod/v4';
import { PanelPlugin } from '../../plugin-system';

type ValidationError = {
  code: string;
  message: string;
};
type ValidationResult = {
  success: boolean;
  errors?: ValidationError[];
};

/**
 * Handles schema validate for the panel plugin.
 */
export function validateSchema(schema: PanelPlugin['schema'], spec: unknown): ValidationResult {
  const results = schema?.safeParse(spec);
  let errors: ValidationError[] | undefined = undefined;
  if (results?.success === false) {
    errors = results.error.issues.map((error: z.ZodIssue) => {
      const path = error.path.join('.');
      return {
        code: error.code,
        message: `[${error.code}] \`spec.${path}\` ${error.message}`,
      };
    });
  }

  return {
    success: results?.success ?? true,
    errors,
  };
}
